import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.css'],
})
export class HeroSectionComponent {
  @Input() data!: any;
  services: any = [];
  @Input() language!: string;
  isDetails: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.services = this.data.services;
    this.isDetails = this.data.isDetails;
  }

  getLinkUrl(item: any): string {
    var url = '';
    if (item.htmlContent) {
      url =
        '/' +
        this.language +
        '/details/home-page/hero/' +
        item.title.replaceAll(' ', '-').toLowerCase();
    } else {
      url =
        '/' +
        this.language +
        '/details/service-page/' +
        item.fileName +
        '/' +
        item.title.replaceAll(' ', '-').toLowerCase();
    }
    return url;
  }
}
